import { Components } from "../../utils/components";
import { BaseSubmittableForm } from "./base-submittable-form";
export class VacancyApplicationForm extends BaseSubmittableForm {
  constructor(element) {
    super(element); // Jquery may not work here.
  }

  init() {// Jquery may not work here
  }

  bindFields() {}

  onProgress(progressEvent) {
    const percentCompleted = Math.round(progressEvent.loaded * 100 / progressEvent.total);
    document.title = "Please wait " + percentCompleted + "%";
    this.form.querySelector(".spinner span").innerText = percentCompleted + "%";
  }

  submit() {
    if (this.isSubmitting()) {
      return;
    }

    this.beginSubmitting();
    this.delay(600).then(() => {
      this.doSubmit(["#vacancy-application-form"], null).then(result => {
        if (result != null) {
          this.endSubmitting();
          window.recaptchaInit();
        }
      });
    });
  }

}
Components.data(VacancyApplicationForm, "vacancyApplicationForm");